export default "__VITE_ASSET__Dev$basM__"